<template>
    <svg
        v-if="customer_group === 'cltn'"
        width="160"
        height="16"
        viewBox="0 0 160 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M65.2556 0.285889H60.7903V14.2659H75.1933V10.7015H65.2556V0.285889Z"
            fill="#282828"
        />
        <path
            d="M37.6108 1.03545C36.5423 0.238537 35.2012 0.0700684 29.3919 0.0700684C23.5826 0.0700684 22.2415 0.238537 21.173 1.03545C20.1252 1.85412 19.7892 3.2984 19.7892 7.18073C19.7892 11.063 20.1035 12.6758 21.173 13.5125C22.2415 14.3094 23.5608 14.4778 29.3919 14.4778C35.223 14.4778 36.5423 14.3094 37.6108 13.5125C38.6794 12.672 38.9945 11.2069 38.9945 7.18073C38.9945 3.15454 38.6803 1.85412 37.6108 1.03545ZM34.1109 10.3475C33.5638 10.7659 32.8095 10.852 29.4345 10.852C26.0595 10.852 25.22 10.7696 24.6758 10.3475C24.1713 9.95097 24.0464 9.38216 24.0464 7.64164C24.0464 5.90113 24.1287 5.02093 24.4249 4.51742C24.8433 3.76311 25.3808 3.69874 29.3928 3.69874C33.313 3.69874 33.8175 3.76311 34.2566 4.37073C34.6144 4.85341 34.7393 5.67209 34.7393 7.66341C34.7393 9.65473 34.5926 9.96895 34.1099 10.3485L34.1109 10.3475Z"
            fill="#282828"
        />
        <path
            d="M122.253 1.03545C121.185 0.238537 119.844 0.0700684 114.035 0.0700684C108.225 0.0700684 106.884 0.238537 105.816 1.03545C104.768 1.85412 104.432 3.2984 104.432 7.18073C104.432 11.063 104.746 12.6758 105.816 13.5125C106.884 14.3094 108.203 14.4778 114.035 14.4778C119.866 14.4778 121.185 14.3094 122.253 13.5125C123.322 12.672 123.637 11.2069 123.637 7.18073C123.637 3.15454 123.323 1.85412 122.253 1.03545ZM118.754 10.3475C118.206 10.7659 117.452 10.852 114.077 10.852C110.702 10.852 109.863 10.7696 109.318 10.3475C108.814 9.95097 108.689 9.38216 108.689 7.64164C108.689 5.90113 108.771 5.02093 109.068 4.51742C109.486 3.76311 110.023 3.69874 114.035 3.69874C117.956 3.69874 118.46 3.76311 118.899 4.37073C119.257 4.85341 119.382 5.67209 119.382 7.66341C119.382 9.65473 119.235 9.96895 118.753 10.3485L118.754 10.3475Z"
            fill="#282828"
        />
        <path
            d="M14.616 8.81237C14.616 9.30357 14.6434 9.92349 14.3188 10.2869C13.7822 10.8879 11.3876 10.8964 9.49191 10.8964C7.86592 10.8964 5.57836 10.9324 4.87136 10.4469C4.13597 9.94242 4.14638 9.06412 4.14638 7.28196C4.14638 4.81741 4.29876 4.35933 4.96601 3.85772C5.57079 3.40248 7.71165 3.50658 9.49191 3.50658C11.2722 3.50658 13.7859 3.45264 14.1513 3.98549C14.3197 4.21831 14.3623 4.40382 14.4011 5.2225H18.6592V4.52875C18.6592 2.2232 18.1983 1.19347 16.9177 0.585851C15.9741 0.124931 13.0581 0 9.47204 0C2.30081 0 1.33449 0.357756 0.537581 2.11625C0.201592 2.91316 0 4.0631 0 7.27344C0 10.4838 0.0974826 11.9953 1.0515 13.0818C1.25688 13.3156 1.52472 13.4916 1.83516 13.6497C2.98982 14.2355 4.14544 14.404 9.47204 14.404C11.6602 14.404 16.1218 14.4333 17.2159 13.6497C18.31 12.866 18.8835 11.5646 18.8835 9.36225V8.80195H14.6046L14.616 8.81237Z"
            fill="#282828"
        />
        <path
            d="M139.66 0.285889L139.764 10.7015H139.324L132.009 0.285889H124.541V14.2659H128.881L128.777 3.84453H129.239L136.6 14.2659H144V0.285889H139.66Z"
            fill="#282828"
        />
        <path
            d="M103.528 0.285889H99.0627V14.2659H103.528V0.285889Z"
            fill="#282828"
        />
        <path
            d="M81.2373 3.84453H87.4649V14.2659H91.9303V3.84453H98.1579V0.285889H81.2373V3.84453Z"
            fill="#282828"
        />
        <path
            d="M80.3334 0.285889H75.8681V14.2659H80.3334V0.285889Z"
            fill="#282828"
        />
        <path
            d="M57.2752 9.27903L53.6853 11.9083L54.8608 14.2696L59.8855 14.2659L57.2752 9.27903ZM56.5389 7.86693L52.5732 0.285889H45.9434L41.9314 7.86693L41.9295 7.86977H46.6305L49.202 2.70595L49.5929 3.48866L51.7744 7.86977H56.5408L56.5389 7.86693ZM38.5422 14.2659H43.5479L44.7158 11.9083L41.1657 9.30837L38.5422 14.2659Z"
            fill="#282828"
        />
    </svg>

    <svg
        width="160"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-else
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.857 4.454 26.552 15.64h5.745l6.298-11.185h-5.738ZM40.13 4.454h5.592l1.675 8.354 11.628-8.354H65L49.44 15.64h-7.074L40.13 4.454ZM130.031 15.64h23.671l1.336-2.374h-16.136c-1.79 0-1.629-.294-1.352-.783l.745-1.322.061-.114h12.612c2.757 0 5.729-.734 7.089-3.15L160 4.456c-5.922 0-12.435-.017-18.349-.017-2.757 0-5.729.735-7.089 3.15-1.505 2.676-3.018 5.368-4.531 8.052Zm9.431-6.543.223-.392c.714-1.264 1.836-1.9 3.472-1.9h9.769l-.222.391c-.73 1.265-1.813 1.901-3.257 1.901h-9.985ZM108.802 4.454H96.206c-2.758 0-5.73.734-7.09 3.15l-4.523 8.035h5.745l4.101-7.26c.584-1.061 2.105-1.575 3.303-1.575h9.746l1.314-2.35ZM27.312 0 24.8 4.455H11.62c-2.757 0-5.73.734-7.089 3.149l-1.374 2.431L0 15.64h18.925c2.757 0 5.73-.734 7.089-3.15l1.367-2.43C29.27 6.713 31.152 3.36 33.04.015V.008L27.311 0Zm-3.833 6.804-2.757 4.887c-.584 1.06-2.105 1.575-3.303 1.575H7.081L9.84 8.379c.583-1.06 2.104-1.575 3.302-1.575H23.48ZM104.47 15.64c5.914.008 12.442 0 18.356 0 2.757 0 5.73-.735 7.089-3.15l1.913-3.394h-17.934l.222-.391c.722-1.224 1.759-1.901 3.51-1.901h15.492l1.321-2.35h-18.356c-2.758 0-5.73.734-7.089 3.15l-1.944 3.442h17.934l-.222.4c-.715 1.2-1.759 1.82-3.441 1.82h-15.515l-1.336 2.373ZM58.871 15.64h23.671l1.337-2.374H67.742c-1.813 0-1.628-.294-1.344-.783l.745-1.322.061-.114h12.612c2.757 0 5.73-.734 7.089-3.15l1.943-3.442c-5.922 0-12.435-.017-18.349-.017-2.757 0-5.73.735-7.089 3.15-1.513 2.676-3.026 5.368-4.539 8.052Zm9.432-6.543.222-.392c.715-1.264 1.836-1.9 3.472-1.9h9.77l-.223.391c-.73 1.265-1.813 1.901-3.257 1.901h-9.984Z"
            fill="#000"
        />
    </svg>
</template>

<script>
export default {
    name: "Logo",
    props: {
        customer_group: {
            type: String,
            default: "dvrs",
        },
    },
};
</script>
